<template>
  <div class="overflow-x-auto">
    <table class="table-auto border-collapse border border-gray-300 w-full text-sm">
      <thead>
      <tr>
        <th
            v-for="header in displayedHeaders"
            :key="header.key"
            class="border border-gray-300 px-4 py-2 bg-gray-100 text-left column-width"
        >
          {{ header.key }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, index) in rowData" :key="index">
        <td
            v-for="header in displayedHeaders"
            :key="header.key"
            class="border border-gray-300 px-4 py-2 text-center column-width"
        >
          {{ row[header.key] }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "AdminInBodyTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    rowData: {
      type: Array,
      required: true,
    },
    selectedHeaders: {
      type: Array,
      required: true,
    },
  },
  computed: {
    displayedHeaders() {
      if (this.selectedHeaders.length === 0) {
        return this.headers;
      }
      const selectedKeys = this.selectedHeaders.map(h => h.id);
      return this.headers.filter(h => selectedKeys.includes(h.key));
    }
  },
  mounted() {
  }

};
</script>

<style scoped>
.table-auto {
  border-spacing: 0;
}

.column-width {
  width: 120px; /* 각 열의 너비 */
  min-width: 120px;
}
</style>
